import { render } from "./PeopleLloyd.vue?vue&type=template&id=34aad19a"
import script from "./PeopleLloyd.vue?vue&type=script&lang=js"
export * from "./PeopleLloyd.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__